import React from 'react';

import { ColorsType, variables } from '../variables';

type ArrowRightProps = {
  stroke?: ColorsType,
  width?: string,
  height? : string
}

export  const ArrowRight: React.FC<ArrowRightProps> = ({
  stroke= 'road-grey-700',
  width = '6',
  height = '10'
}) => {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" stroke={variables.colors[stroke]} xmlns="http://www.w3.org/2000/svg">
      <path d="M1.1618 9.3775L5.44752 5.09179L1.1618 0.806076"  strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
